{
  "fr": {
    "dressingRoom": {
      "lead": "Assemblez une armure et une sous-combinaison et voyez la tenue en 3D. Partagez-la par lien ou connectez-vous pour l'enregistrer.",
      "slots": {
        "helmet": "Casque",
        "torso": "Torse",
        "arms": "Bras",
        "legs": "Jambes",
        "backpack": "Sac à dos",
        "undersuit": "Sous-combinaison",
        "primary": "Principale",
        "secondary": "Secondaire",
        "sidearm": "Arme de poing"
      },
      "size": "S%{size}",
      "choose": "Choisir…",
      "remove": "Retirer",
      "openItem": "Ouvrir la page de l'objet",
      "notFound": "Objet introuvable",
      "noHolo": "Pas encore de modèle 3D",
      "empty": "Choisissez une pièce pour un emplacement pour voir la tenue.",
      "pose": "Pose",
      "copyLink": "Copier le lien",
      "savedOutfits": "Tenues enregistrées",
      "signInToSave": "Connectez-vous pour enregistrer des tenues.",
      "outfitName": "Nom de la tenue",
      "nameTaken": "Vous avez déjà une tenue portant ce nom.",
      "saveNew": "Enregistrer comme nouvelle tenue",
      "saveChanges": "Enregistrer les modifications",
      "noOutfits": "Aucune tenue enregistrée pour l'instant.",
      "pieces": {
        "one": "%{count} pièce",
        "other": "%{count} pièces"
      },
      "confirmDelete": "Supprimer la tenue %{name} ?",
      "messages": {
        "saved": "Tenue enregistrée.",
        "saveFailed": "La tenue n'a pas pu être enregistrée.",
        "deleteFailed": "La tenue n'a pas pu être supprimée.",
        "linkCopied": "Lien copié.",
        "copyFailed": "Le lien n'a pas pu être copié."
      },
      "groups": {
        "armour": "Armure",
        "weapons": "Armes",
        "gear": "Équipement"
      },
      "hold": "Tenir en main",
      "bodies": {
        "male": "Homme",
        "female": "Femme"
      },
      "positionPending": "Position pas encore exportée",
      "fit": {
        "noPort": "%{item} n'a pas d'emplacement pour cela",
        "doesNotFit": "Ne convient pas à %{item}",
        "noWornPiece": "Aucune pièce portée n'a de place pour ceci"
      },
      "armorSets": {
        "open": "Ensembles d'armure",
        "count": {
          "one": "%{count} ensemble",
          "other": "%{count} ensembles"
        }
      },
      "gearHint": "Portez un torse, des jambes ou une sous-combinaison pour emporter grenades, chargeurs, injecteurs et outils.",
      "gear": {
        "grenade": "Grenade %{number}",
        "magazine": "Chargeur %{number}",
        "gadget": "Gadget",
        "medpen": "Medpen %{number}",
        "oxypen": "Oxypen %{number}",
        "utility": "Utilitaire %{number}"
      },
      "saveBlocked": "Corrigez ce qui est signalé ci-dessus pour enregistrer cette tenue.",
      "storage": {
        "title": "Rangement",
        "space": "%{used} sur %{capacity}",
        "add": "Ajouter un objet",
        "fewer": "Un de moins",
        "more": "Un de plus",
        "pickerTitle": "Ajouter à %{piece}",
        "problems": {
          "noStorage": "Rien de porté ici ne peut contenir ces objets.",
          "overCapacity": "Contient plus que ce que cette pièce peut accueillir.",
          "tooLarge": "Contient un objet trop grand pour cette pièce.",
          "unmeasured": "Contient un objet sans taille mesurée."
        },
        "misfit": {
          "unmeasured": "Taille non mesurée",
          "tooLarge": "Trop grand pour cette pièce",
          "noRoom": "Plus assez de place"
        }
      },
      "gearNone": "Ce que vous portez n'a pas d'emplacement d'équipement.",
      "gearColumns": {
        "magazine": "Munitions",
        "grenade": "Grenades",
        "medpen": "Medpens",
        "oxypen": "Oxypens"
      }
    }
  }
}
